import EventProviderWC from '@ui5/webcomponents-base/dist/EventProvider.js';
export const MediaEventProvider = new EventProviderWC();
export const OrientationEventProvider = new EventProviderWC();
export const ResizeEventProvider = new EventProviderWC();
